import React from "react";
import Box from "@mui/material/Box";
import { Link as RouterLink } from "react-router-dom";

const GetEBookButton = () => (
    <Box sx={{ textAlign: "center" }}>
        {/* Make only the link yellow */}
        <Box
            component={RouterLink}
            to="/order"
            sx={{
                textDecoration: "none",
                display: "inline-block",
                fontWeight: 700,
                fontSize: 21,
                color: "text.primary",
                px: 4,
                py: 2,
                borderRadius: 2,
                mb: 1,
                bgcolor: "custom.yellow",
            }}
        >
            Get Happy US EBook - $37
            <br />
            <Box
                component="small"
                sx={{
                    display: "block",
                    fontWeight: 400,
                    fontSize: 17,
                    mt: 0.5,
                    color: "text.primary",
                    
                }}
            >
                Instant Download | Small Changes, Lifelong Impact
            </Box>
        </Box>
    </Box>
);

export default GetEBookButton;